module.exports = __webpack_public_path__ + "img/gravier_rouge.1c7ccaf8.jpg";